<template>
  <section class="promo-block ptb-100">
    <div class="container">
      <div class="row justify-content-center">
        <div
          v-for="(item, index) in metrics"
          :key="index"
          :class="`col-md-6 col-lg-4 dot-bg-shape dot-bg-${index + 1}`"
        >
          <div class="promo-counter text-center white-bg p-5">
            <div class="counter-number d-inline-flex align-items-center mb-4">
              <h2 class="mb-0">{{ item.value }}</h2>
              <span :class="`ml-2 p-2 rounded-circle ${item.color}`">
                <i :class="`fa-solid fa-${item.icon} fa-shake fa-2x`"></i>
              </span>
            </div>
            <p>{{ $t(item.descriptionKey) }}</p>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
const metrics = [
  {
    value: '98%',
    descriptionKey: 'promo_metrics.promo.metrics.description_1',
    icon: 'arrow-up',
    color: 'color-5 color-5-bg',
  },
  {
    value: '87%',
    descriptionKey: 'promo_metrics.promo.metrics.description_2',
    icon: 'arrow-down',
    color: 'color-6 color-6-bg',
  },
  {
    value: '92%',
    descriptionKey: 'promo_metrics.promo.metrics.description_3',
    icon: 'arrow-up',
    color: 'color-5 color-5-bg',
  },
]
</script>
